import type { Bedrooms, CarryBand } from '../types/funnel';

export interface PricingConfig {
  version: string;
  ratesApproved: boolean;
  /** Approved standard hourly rates: whole crew + 1 truck. */
  rates: Record<number, number>;
  /** Admin-only negotiation floors. Server-authorized; never exposed to customers. */
  negotiationFloors: Record<number, number>;
  minimumServiceHours: number;
  travelHours: number;
  surchargePercent: number;
  surchargeBaseApproved: boolean;
  baseHoursByBedroom: Record<Bedrooms, number>;
  stairsUpliftHours: { second: number; third: number };
  elevatorAllowanceHours: number;
  carryPlanningHours: Record<CarryBand, number>;
  packingCrewHoursPer10Boxes: number;
  rangeSpreadHours: number;
  depositAmount: number;
  cancellationNoticeHours: number;
  refundLanguageApproved: boolean;
  cardFeeConfigured: boolean;
}

export const defaultPricingConfig: PricingConfig = {
  version: 'rates-2026-10-06.1',
  ratesApproved: true,
  rates: { 2: 129, 3: 159 },
  negotiationFloors: { 2: 99, 3: 129 },
  minimumServiceHours: 4,
  travelHours: 1,
  surchargePercent: 20,
  surchargeBaseApproved: false,
  baseHoursByBedroom: { studio: 4, '1': 4, '2': 5, '3': 7, '4': 10, '5': 12, few: 4 },
  stairsUpliftHours: { second: 1, third: 2 },
  elevatorAllowanceHours: 0.75,
  carryPlanningHours: { '0_20': 0, '21_40': 0, '41_60': 0.25, '61_100': 0.5, over_100: 0.75, unsure: 0.25 },
  packingCrewHoursPer10Boxes: 1,
  rangeSpreadHours: 1,
  depositAmount: 99,
  cancellationNoticeHours: 72,
  refundLanguageApproved: false,
  cardFeeConfigured: false,
};

export const pricingOpenItems = [
  '20% operating surcharge: calculation base (labor only? labor + travel? before/after extras) not approved — no amount is shown.',
  'Billing increment / rounding, taxes and card-fee eligibility not configured. No blanket 4% fee.',
  'Refund exceptions for 72-hour cancellation/reschedule rule must come from the approved contract.',
  'Packing/materials catalog prices not approved — shown as “priced by our team”.',
  'Long-carry threshold, stair or access fees: none approved, so none charged.',
];
